function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M66.27 23.696l-22.99-3.341L33-.475l-10.281 20.83L-.27 23.696 16.365 39.91l-3.927 22.896L33 51.996l20.562 10.811-3.927-22.897L66.27 23.696zM35.327 47.57L33 46.348V10.822l5.797 11.746 1.163 2.357 2.602.378 12.963 1.884-9.38 9.143-1.882 1.835.444 2.591 2.214 12.91-11.594-6.096z"
});

function SvgStarHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 63,
    width: 67,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgStarHalf;